<template>
    <input ref="input" :type="type" :class="inputClass" :disabled="disabled" class="form-control" :value="numberStr" v-on:input="onInput" v-on:blur="onBlur" v-on:focus="onFocus" v-on:keypress.enter="blur"/>
</template>

<script>

export default {
    props:{
        value:Number,
        disabled:{
            type:Boolean,
            default:null
        },
        inputClass:{
            type:String,
            default:null
        }
    },
    data(){
        return{
            type:'text',
            numberStr:""
        }
    },
    watch:{
        value(newV,oldV){
            if(!isNaN(oldV) && !isNaN(newV) && this.type == 'text'){
                this.numberStr = this.toNumberStr(this.value)
            }
        },
    },
    mounted(){
        this.numberStr = this.toNumberStr(this.value)
    },
    methods:{
        toNumberStr(n){
            let nn = n
            if(n == null || n == "" || n == 'NaN' || isNaN(n)){ nn = 0 }
            return new Intl.NumberFormat('tr-TR', {
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(nn)
        },
        // Alan iki farklı biçimde okunabiliyor: odaklıyken tarayıcı ham sayı veriyor
        // ("418.7", nokta = ondalık), odak dışındayken toNumberStr'in ürettiği tr-TR
        // biçimli metin duruyor ("1.760,52", nokta = binlik). Eskiden ikisi de aynı
        // şekilde parse edildiği için binlik ayıracı ondalık sanılıyor ve parseFloat
        // ikinci noktada kesiyordu: "41.870,00" -> 41,87. Virgülün varlığı iki durumu
        // kesin ayırt ediyor, çünkü biçimli metin her zaman ondalık virgül içerir.
        parseAmount(s){
            if(s == null){ return null }
            const t = String(s).trim()
            if(t === ''){ return null }
            const n = t.includes(',')
                ? parseFloat(t.replace(/\./g,'').replace(',','.'))
                : parseFloat(t)
            return isNaN(n) ? null : n
        },
        onInput($e){
            // 0 geçerli bir fiyat; eski "|| null" onu null'a düşürüyordu.
            this.$emit('update-value',this.parseAmount($e.target.value))
        },
        onBlur(){
            this.type = 'text'
            this.numberStr = this.toNumberStr(this.value)
        },
        onFocus(){
            this.numberStr = this.value
            this.type = 'number' 
        },
        blur(){
            this.$refs.input.blur()
        }
    },
}
</script>

<style>

</style>

